export const dict = {
    en: {
        'Sign In': 'Sign In', // Tab header
        'Sign in': 'Login', // Button label
    }
};